import React, { FC } from 'react';
import { Icon, IconProps } from '../Icon';

export const Minus: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M7 16c0-.6.4-1 1-1h16a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Z"
    />
  </Icon>
);
